import styled from "@emotion/styled";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";

export const FullscreenLoading = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.82);
  z-index: 1200;
`;

export const SettingsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
  max-width: 1100px;
  align-self: center;

  @media (max-width: 1200px) {
    width: 65%;
  }

  @media (max-width: 960px) {
    width: 100%;
  }
`;

export const EditCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dfe3ea;
  border-radius: 18px;
  overflow: visible;
`;

export const SettingsCardBody = styled.div`
  padding: 20px;
  font-size: 15px;
  color: #475467;
`;

export const SettingsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px;
`;

export const SettingsSectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const SettingsSectionIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(223, 32, 46, 0.1);
  color: #df202e;
  flex-shrink: 0;
`;

export const MeetingGapSectionIcon = styled(SettingsSectionIcon)`
  background: rgba(253, 154, 0, 0.1);
  color: #fd9a00;
`;

export const ConfirmationSectionIcon = styled(SettingsSectionIcon)`
  background: rgba(0, 188, 125, 0.1);
  color: #00bc7d;
`;

export const ShareAgendaSectionIcon = styled(SettingsSectionIcon)`
  background: rgba(43, 127, 255, 0.1);
  color: #2b7fff;
`;

export const DayOffSectionIcon = styled(SettingsSectionIcon)`
  background: rgba(251, 44, 54, 0.1);
  color: #fb2c36;
`;

export const SettingsSectionTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SettingsSectionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  color: #101828;
`;

export const SettingsSectionDescription = styled.div`
  font-size: 13px;
  line-height: 16px;
  color: #667085;
`;

export const WorkDayCard = styled.div`
  border: 1px solid #eaecf0;
  border-radius: 12px;
  padding: 14px 16px;
  background: #ffffff;
`;

export const WorkDayHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const WorkDayHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const WorkDayTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #344054;
`;

export const WorkDayUnavailable = styled.div`
  font-size: 12px;
  color: #667085;
`;

export const WorkDayPeriods = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
  padding-left: 28px;
`;

export const WorkPeriodRow = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr 16px 1fr 24px;
  align-items: center;
  gap: 8px;
`;

export const WorkPeriodLabel = styled.div`
  font-size: 11px;
  color: #667085;
  white-space: nowrap;
`;

export const WorkPeriodSeparator = styled.div`
  font-size: 12px;
  color: #667085;
  text-align: center;
`;

export const TimeDropdown = styled(Dropdown)`
  width: 100%;
  min-height: 32px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  box-shadow: none;

  .p-dropdown-label {
    padding: 6px 10px;
    font-size: 12px;
    color: #344054;
  }

  .p-dropdown-trigger {
    width: 28px;
    color: #98a2b3;
  }
`;

export const DeletePeriodButton = styled.button`
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  color: #101828;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
`;

export const AddPeriodButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  height: 30px;
  margin-top: 4px;
  padding: 0 12px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  background: #ffffff;
  color: #344054;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
`;

export const SettingsHint = styled.div`
  font-size: 12px;
  color: #667085;
`;

export const DayOffFormCard = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 14px;
  border-radius: 12px;
  background: #f8fafc;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const DayOffField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DayOffDateField = styled(DayOffField)`
  width: 100%;
  max-width: 140px;
`;

export const DayOffDescriptionField = styled(DayOffField)`
  flex: 1 1 auto;
  width: 100%;
`;

export const DayOffCalendarWrapper = styled.div`
  .p-inputtext {
    color: #344054 !important;
  }

  input {
    color: #344054 !important;
  }

  input::placeholder {
    color: #98a2b3 !important;
  }
`;

export const DayOffLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #344054;
`;

export const DayOffInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 13px;
  color: #344054;
  outline: none;

  &::placeholder {
    color: #98a2b3;
  }
`;

export const DayOffAction = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
`;

export const DayOffAddButton = styled.button<{
  color: string;
  disabled?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: ${({ color, disabled }) => (disabled ? "#dfe3ea" : color)};
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
`;

export const DayOffList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const DayOffChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #ffffff;
  color: #344054;
  font-size: 13px;
`;

export const DayOffChipRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 0;
  background: transparent;
  color: #667085;
  cursor: pointer;
  padding: 0;
`;

export const DayOffSuggestionsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
`;

export const DayOffSuggestionsTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #101828;
`;

export const DayOffSecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #ffffff;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const ShareAgendaField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ShareAgendaLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #344054;
`;

export const ShareAgendaMultiSelect = styled(MultiSelect)`
  width: 100%;
  min-height: 44px;
  height: auto;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  box-shadow: none;
  overflow: visible;
  padding: 4px 0;

  .p-multiselect-label-container {
    display: block;
    min-height: 42px;
    height: auto;
    padding: 0 8px;
    overflow: visible;
    width: calc(100% - 40px);
  }

  .p-multiselect-label {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 6px 4px;
    font-size: 14px;
    color: #344054;
    white-space: normal;
    height: auto;
    width: 100% !important;
    align-content: flex-start;
    box-sizing: border-box;
  }

  .p-placeholder {
    color: #98a2b3;
  }

  .p-multiselect-trigger {
    width: 40px;
    min-width: 40px;
    color: #98a2b3;
  }

  .p-multiselect-token {
    display: inline-flex !important;
    width: auto !important;
    flex: 0 0 auto;
    background: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .p-multiselect-token-label {
    padding: 0 !important;
  }

  .p-multiselect-token-icon {
    color: #667085;
    margin-left: 6px;
  }
`;

export const ShareAgendaChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 6px;
  background: #1677ff;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
`;

export const ShareAgendaEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 180px;
  border-radius: 12px;
  background: #ffffff;
  color: #667085;
  text-align: center;

  i {
    font-size: 46px;
    color: #98a2b3;
  }
`;

export const MeetingGapField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const MeetingGapDropdown = styled(Dropdown)`
  width: 50%;
  min-height: 42px;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  box-shadow: none;

  .p-dropdown-label {
    padding: 10px 12px;
    font-size: 14px;
    color: #344054;
  }

  .p-dropdown-trigger {
    width: 40px;
    color: #98a2b3;
  }
`;

export const MeetingGapHint = styled.div`
  font-size: 13px;
  color: #667085;
`;

export const ConfirmationField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const ConfirmationTextarea = styled.textarea`
  width: 100%;
  min-height: 108px;
  padding: 14px 16px;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  resize: none;
  font-size: 14px;
  line-height: 1.5;
  color: #344054;
  outline: none;

  &::placeholder {
    color: #98a2b3;
  }

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const ConfirmationVariablesRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ConfirmationVariablesLabel = styled.div`
  font-size: 13px;
  color: #667085;
`;

export const ConfirmationVariableChip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #344054;
  font-size: 13px;
  font-family: monospace;
`;

export const ConfirmationPreviewBox = styled.div`
  width: 100%;
  min-height: 62px;
  padding: 16px;
  border-radius: 12px;
  background: #f2f2f2;
  color: #344054;
  font-size: 14px;
  line-height: 1.5;
`;

export const SaveActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 0 4px 12px;
`;

export const SaveButton = styled.button<{
  color: string;
  disabled?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 180px;
  height: 44px;
  padding: 0 18px;
  border: 0;
  border-radius: 12px;
  background: ${({ color, disabled }) => (disabled ? "#d0d5dd" : color)};
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
`;
